import { useParams } from 'react-router-dom';
import { capitalize, replace } from 'lodash';
import { useGetDatasetQuery } from '~/api/v2/hooks';
import { DetailsDataConfig } from '~/pages/DatasetDetailsPage/components/types';
import { useWbsOrCostCenter } from '..';

const useGeneralDataConfig = () => {
  const datasetId = +useParams().id!;
  const { data } = useGetDatasetQuery({ datasetId });
  const { displayValue: wbsOrCostCenter } = useWbsOrCostCenter({
    wbsCodeId: data?.wbs_code_id,
    costCenterId: data?.cost_center_id,
  });

  const locationDescriptions = (locations?: string[]) =>
    !locations ? '—' : locations?.map((el) => el.replace('GeoLocation_', ' ')).join(', ');

  const generalDataConfig: DetailsDataConfig[] = [
    { label: 'dataset name', value: data?.name },
    { label: 'dataset id number', value: data?.mdt_id },
    { label: 'description', value: data?.description, fullWidth: true },
    { label: 'data location', value: locationDescriptions(data?.geo_location_descriptions) },
    { label: 'dataset status', value: data?.status },
    { label: 'WBS / Cost Center Code', value: wbsOrCostCenter || '—' },
    { label: 'ou owner', value: data?.source_ou },
    { label: 'de-identified status', value: capitalize(replace(data?.de_identified || '—', '_', ' ')) },
    { label: 'data classification', value: data?.data_classification },
    { label: 'provenance', value: data?.provenance, fullWidth: true },
    { label: 'data source category', value: data?.collection_source },
    { label: 'data source type', value: data?.data_format?.join(', ') || '—' },
    { label: 'legal relationship', value: data?.legal_relationship_tag },
    { label: 'legal relationship qualifier', value: data?.legal_relationship_qualifier },
    { label: 'anatomy', value: data?.anatomy?.join(', ') || '—' },
    { label: 'modality', value: data?.modality?.join(', ') || '—' },
    { label: 'dimensionality', value: data?.dimensionality?.join(', ') || '—' },
    { label: 'restriction tags', value: data?.restriction_description?.join(', ') || '—' },
  ];

  return { generalDataConfig };
};

export default useGeneralDataConfig;
